import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Note } from '../../interfaces';

interface EditNotesPopupProps {
    onClose: () => void;
    note: Note | null;
    onSave: (text: string) => void;
}


const EditNotesPopup: React.FC<EditNotesPopupProps> = ({ onClose, note, onSave }) => {
    const [editedNoteText, setEditedNoteText] = useState(note?.note || '');
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

    const handleNoteTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setEditedNoteText(e.target.value);
    };

    const handleSaveChanges = () => {
        onSave(editedNoteText);
        onClose();
    };

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1001,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    });

    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h3>Edit Note</h3>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='px-4 pb-3'>
            <textarea
                    value={editedNoteText}
                    onChange={handleNoteTextChange}
                    placeholder='Enter updated note...'
                    rows={6}
                    className='w-100 mt-2'
                    style={{ borderRadius: '4px', padding: '8px' }}
                />
                <div className='d-flex mt-4 align-items-center justify-content-end' style={{ gap: '10px' }}>
                    <div className='d-flex mt-4 align-items-center justify-content-end' style={{ gap: '10px' }}>
                        <button className='blue-filled-btn align-items-center d-flex' onClick={handleSaveChanges}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
             
            </div>
        </div>
    );
};

export default EditNotesPopup;

